<template>
    <section class="apartments-owner">
        <h2 class="apartments-owner__title">Owner information:</h2>
        <p class="apartments-owner__info">{{ owner.name }}</p>
        <p class="apartments-owner__info">&#9990; {{ owner.phone }}</p>
        <p class="apartments-owner__info">&#9993; {{ owner.email }}</p>
    </section>
</template>

<script>

export default {
    name: 'ApartmentsOwner',
    props: {
        owner: {
            type: Object,
            required: true
        }
    },

}
</script>

<style lang="scss" scoped>
.apartments-owner {
    padding: 20px;
    background: #e1efff;
    font-weight: 400;

    &__title {
        font-size: 18px;
        font-weight: 700;
        margin-bottom: 20px;
    }

    &__info {
        margin-top: 6px;
    }
}
</style>